<div class="row my-row justify-content-md-center" style="background:linear-gradient(246.51deg, #CD9BDE 1.65%, #56DFBC 38.16%, #56DFBC 73.97% , #79D6E0 100.23%) no-repeat;padding-top: 40px;">
    <div class="col-sm-4">
        <span class="bienvenue">
            {{ "PUBLIC.HELLO" | translate }}<br/>
            {{ "PUBLIC.TEXT-CONNECT" | translate }}
        </span>

        <div class="card my-5">
            <div class="card-body">
                <p class="card-text" style="font-size: 18px;">
                    {{ "PUBLIC.EXPLORER" | translate }}  Chrome <img src="assets/icons/chrome.svg" style="width: 1.5rem" />
                    Firefox <img src="assets/icons/firefox.svg" style="width: 1.5rem" />
                    Opéra <img src="assets/icons/opera.svg" style="width: 1.5rem" />
                    Internet Explorer <img src="assets/icons/internet-explorer.svg" style="width: 1.5rem" />
                    Edge <img src="assets/icons/edge.svg" style="width: 1.5rem" />
                    Safari <img src="assets/icons/safari.svg" style="width: 1.5rem" />
                </p>
            </div>
        </div>

        <div class="alert alert dismissible fade show alert-danger mt-5" role="alert">
            <h4 class="alert-heading">{{ "PUBLIC.ALERT-LINK-MML-ACCOUNT-TITLE" | translate }}</h4>
            <p [innerHtml]="'PUBLIC.ALERT-LINK-MML-ACCOUNT-TEXT' | translate"></p>
        </div>
    </div>
    <div class="col-sm-6">

    </div>
</div>
